import { useState } from "react";
import { useLocation } from "react-router-dom";
import close from "../../assets/images/close.png";
import plus from "../../assets/images/plus_icon.png";
import {Modal,ModalBody,Button,Form,Input,FormGroup,Label,Row,Col} from "reactstrap";
import axiosInstance from "../../helpers/axios";
import { FormControl, FormControlLabel, FormLabel, Radio,RadioGroup} from "@mui/material";
import { Box } from "@mui/system";

export default function AddAnchorPartner() {
  const [formOpen, setFormOpen] = useState(false);
  const [partnerName, setPartnerName] = useState("");
  const [pan, setPan] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [email, setEmail] = useState("");
  const [ifsc, setIfsc] = useState("");
  const [beneficiaryName, setBeneficiaryName] = useState("");
  const createPartner = () => {
    const data = {
      name: partnerName,
      pan: pan,
      bankAccountNumber: accountNumber,
      phone: phoneNumber,
      email: email,
      beneficiaryName: beneficiaryName,
      ifsc: ifsc,
      partnerType: partnerType,
      notes: notes,
    };
    axiosInstance
      .post(`/channel-partners/create-partner`, data, {
        headers: {
        },
      })
      .then((res) => {
        alert("Anchor Partner Details added");
        setFormOpen(false);
        window.location.reload();
      })
      .catch((err) => {
        alert(err.response.data.message);
      });
  };

  const location = useLocation();
  const user = null;

  const [partners, setPartners] = useState([]);
  const popUpForm = () => {
    setFormOpen(true);
  };

  const [partnerType, setPartnerType] = useState("Anchor");
  const [notes, setNotes] = useState("");

  return (
    <div>
      <p
        style={{
          fontFamily: "Inter-Medium",
          fontSize: "16px",
          padding: "10px",
          fontWeight: "500",
          textTransform: "capitalize",
          cursor: "pointer",
          height: "34px",
          fontFamily: "Inter-Medium",
          fontSize: "16px",
          backgroundColor: "#D22129",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          borderRadius: "6px",
        }}
        onClick={() => popUpForm()}
      >
        <img src={plus} style={{ marginRight: "10px" }} />
        Add Anchor Partner
      </p>

      {formOpen && (
        <>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 999,
            }}
          ></div>
          <Modal
            style={{ top: "5%", backgroundColor: "white", maxWidth: "50%" }}
            size="lg"
            className="edit-form "
            isOpen={formOpen}
          >
            <div
              style={{
                borderTopLeftRadius: "10px",
                borderTopRightRadius: "10px",
                display: "flex",
                flexDirection: "row",
                padding: "20px",
                justifyContent: "space-between",
                backgroundColor: "#E9E9E9",
                height: "50px",
                alignItems: "center",
              }}
            >
              <p className="heading">Add Anchor Partner</p>
              <img
                style={{ height: "1.5em", width: "1.5em" }}
                className="image1"
                onClick={() => setFormOpen(!formOpen)}
                src={close}
              />
            </div>

            <ModalBody>
              <Form>
                <FormGroup>
                  <Row>
                    <Col>
                      <Row>
                        <div title="Add Partner Details">
                          <Form>
                            <div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <FormGroup style={{ marginRight: "10px" }}>
                                  <Label htmlFor="">
                                    <span
                                      style={{
                                        fontFamily: "Inter-Medium",
                                        fontSize: "16px",
                                        fontWeight: "600",
                                      }}
                                    >
                                      Partner Name
                                    </span>{" "}
                                  </Label>
                                  <Input
                                    style={{ width: "15em" }}
                                    type="text"
                                    name="name"
                                    id="name"
                                    placeholder="Partner Name Here"
                                    onChange={(e) =>
                                      setPartnerName(e.target.value)
                                    }
                                  />
                                </FormGroup>
                                <FormGroup>
                                  <Label htmlFor="phoneNumber">
                                    <span
                                      style={{
                                        fontFamily: "Inter-Medium",
                                        fontSize: "16px",
                                        fontWeight: "600",
                                      }}
                                    >
                                      Phone
                                    </span>
                                    <span style={{ color: "red" }}>*</span>
                                  </Label>
                                  <Input
                                    style={{ width: "15em" }}
                                    type="tel"
                                    name="phonenumber"
                                    id="phonenumber"
                                    placeholder="Phone Number"
                                    onChange={(e) =>
                                      setPhoneNumber(e.target.value)
                                    }
                                  />
                                </FormGroup>
                                <FormGroup>
                                  <Label htmlFor="email">
                                    <span
                                      style={{
                                        fontFamily: "Inter-Medium",
                                        fontSize: "16px",
                                        fontWeight: "600",
                                      }}
                                    >
                                      Email
                                    </span>
                                    <span style={{ color: "red" }}>*</span>
                                  </Label>

                                  <Input
                                    style={{ width: "15em" }}
                                    type="email"
                                    name="email"
                                    id="email"
                                    placeholder="email "
                                    onChange={(e) => setEmail(e.target.value)}
                                  />
                                </FormGroup>
                              </div>
                            </div>
                            <div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <FormGroup style={{ marginRight: "10px" }}>
                                  <Label htmlFor="instituteName">
                                    <span
                                      style={{
                                        fontFamily: "Inter-Medium",
                                        fontSize: "16px",
                                        fontWeight: "600",
                                      }}
                                    >
                                      PAN
                                    </span>
                                    <span style={{ color: "red" }}>*</span>
                                  </Label>
                                  <Input
                                    style={{ width: "15em" }}
                                    type="text"
                                    name="pan"
                                    id="pan"
                                    placeholder="PAN"
                                    onChange={(e) => setPan(e.target.value)}
                                  />
                                </FormGroup>
                                <FormGroup style={{ marginRight: "10px" }}>
                                  <Label htmlFor="">
                                    <span
                                      style={{
                                        fontFamily: "Inter-Medium",
                                        fontSize: "16px",
                                        fontWeight: "600",
                                      }}
                                    >
                                      Bank Account Number
                                    </span>
                                    <span style={{ color: "red" }}>*</span>
                                  </Label>
                                  <Input
                                    style={{ width: "15em" }}
                                    type="text"
                                    name="account"
                                    id="account"
                                    placeholder="Account Number"
                                    onChange={(e) =>
                                      setAccountNumber(e.target.value)
                                    }
                                  />
                                </FormGroup>
                                <FormGroup style={{ marginRight: "10px" }}>
                                  <Label htmlFor="">
                                    <span
                                      style={{
                                        fontFamily: "Inter-Medium",
                                        fontSize: "16px",
                                        fontWeight: "600",
                                      }}
                                    >
                                      Beneficiary Name
                                    </span>
                                    <span style={{ color: "red" }}>*</span>
                                  </Label>
                                  <Input
                                    style={{ width: "15em" }}
                                    type="text"
                                    name="Beneficiary Name"
                                    id="Beneficiary Name"
                                    placeholder="Beneficiary Name"
                                    onChange={(e) =>
                                      setBeneficiaryName(e.target.value)
                                    }
                                  />
                                </FormGroup>
                              </div>
                            </div>
                            <div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "start",
                                }}
                              >
                                <FormGroup style={{ marginRight: "10px" }}>
                                  <Label htmlFor="instituteName">
                                    <span
                                      style={{
                                        fontFamily: "Inter-Medium",
                                        fontSize: "16px",
                                        fontWeight: "600",
                                      }}
                                    >
                                      Ifsc
                                    </span>
                                    <span style={{ color: "red" }}>*</span>
                                  </Label>
                                  <Input
                                    style={{ width: "15em" }}
                                    type="text"
                                    name="ifsc"
                                    id="ifsc"
                                    placeholder="ifsc"
                                    onChange={(e) => setIfsc(e.target.value)}
                                  />
                                </FormGroup>

                                {/* radio button begin */}
                                <Box
                                  sx={{
                                    minWidth: 280,
                                    maxWidth: 400,
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "flex-start",
                                  }}
                                >
                                  <FormControl
                                    sx={{
                                      mt: 1,
                                      display: "flex",
                                      flexDirection: "column",
                                      justifyContent: "flex-start",
                                      alignItems: "flex-start",
                                    }}
                                  >
                                    <FormLabel
                                      sx={{
                                        fontFamily: "Outfit",
                                        color: "#000 !important",
                                        fontWeight: "bold",
                                        mb: 2,
                                      }}
                                    >
                                      Partner Type
                                    </FormLabel>

                                    <RadioGroup
                                      row
                                      value={partnerType}
                                      onChange={(e) =>
                                        setPartnerType(e.target.value)
                                      }
                                      sx={{
                                        // columnGap: 4,
                                        "& .MuiFormControlLabel-label": {
                                          color: "#7c7878ff",
                                        },
                                      }}
                                    >
                                      <FormControlLabel
                                        value="Anchor"
                                        control={<Radio />}
                                        label="Anchor"
                                      />
                                    </RadioGroup>
                                  </FormControl>
                                </Box>

                                {/* end */}
                              </div>
                            </div>

                            {/* notes begin */}

                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                              }}
                            >
                              <FormGroup
                                style={{ marginRight: "10px", width: "100%" }}
                              >
                                <Label htmlFor="notes">
                                  <span
                                    style={{
                                      fontFamily: "Inter-Medium",
                                      fontSize: "16px",
                                      fontWeight: "600",
                                    }}
                                  >
                                    Notes
                                  </span>
                                </Label>
                                <Input
                                  type="textarea"
                                  name="notes"
                                  id="notes"
                                  placeholder="Enter your notes here..."
                                  rows={3} // shows approx 5 lines
                                  // style={{ width: "15em" }}
                                  onChange={(e) => setNotes(e.target.value)}
                                />
                              </FormGroup>
                            </div>

                            {/* notes end */}

                            <Button
                              style={{
                                marginLeft: "40%",
                                width: "10em",
                                backgroundColor: "#D32028",
                                marginTop: "20px",
                                border: "none",
                              }}
                              onClick={() => createPartner()}
                              color="primary"
                            >
                              <span
                                style={{
                                  fontFamily: "Inter-Medium",
                                  fontSize: "16px",
                                  fontWeight: "500",
                                  textTransform: "capitalize",
                                  color: "white",
                                }}
                              >
                                Save Details
                              </span>
                            </Button>
                          </Form>
                        </div>
                      </Row>
                    </Col>
                  </Row>
                </FormGroup>
              </Form>
            </ModalBody>
          </Modal>
        </>
      )}
    </div>
  );
}
